import queryString from 'query-string';
import { suggestedKeyword } from 'services/searchSuggestions/types';

export const getSuggestedKeywords = (
  suggestedKeyWords: Array<suggestedKeyword>,
  model: string,
  serialNumber: string
) =>
  suggestedKeyWords?.map((item) => ({
    ...item,
    value: queryString.stringify(
      {
        ...queryString.parse(item.value, { decode: false }),
        ...(model && { model, filterByEquipment: 'true' }),
        ...(serialNumber && { serialNumber })
      },
      { encode: false }
    )
  }));
